import { render, staticRenderFns } from "./geostats.vue?vue&type=template&id=6e724a1b"
import script from "./geostats.vue?vue&type=script&lang=js"
export * from "./geostats.vue?vue&type=script&lang=js"
import style0 from "./geostats.vue?vue&type=style&index=0&id=6e724a1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports